import { Outlet, Link } from "react-router-dom";

const AuthLayout = () => {
  return (
    <div className="app-shell page-gradient">
      <header className="border-b border-goldlight bg-white/90 backdrop-blur">
        <div className="container-page flex min-h-[72px] items-center justify-between gap-4">
          <Link to="/" className="text-2xl font-semibold text-henna">
            Nayra Henna
          </Link>

          <Link
            to="/"
            className="text-sm font-medium text-[#3b2f2f] transition hover:text-henna"
          >
            Return Home
          </Link>
        </div>
      </header>

      <main className="flex min-h-[calc(100vh-73px)] items-center py-10">
        <div className="container-page w-full">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AuthLayout;